module.exports = __webpack_public_path__ + "static/media/Night Mish.46644ff1.svg";